import { type BasicCheckMerchantsResponse } from '@redteclab/api/clients/bully'

type DeliverySlotDayAndTime = {
  deliveryDay: string
  deliveryEndTime: string
}

export const nowBasicCheckResponseAccessorGetNowFirstDeliverySlotDayAndTime = (
  merchantsResponse: BasicCheckMerchantsResponse | undefined,
): DeliverySlotDayAndTime | undefined => {
  if (!merchantsResponse?.slots?.[0]) {
    return undefined
  }

  const [{ deliveryDay, deliveryEndTime }] = merchantsResponse.slots

  if (!deliveryDay || !deliveryEndTime) {
    return undefined
  }

  const [hoursDeliveryEndTime] = deliveryEndTime.split(':')

  return {
    deliveryDay,
    deliveryEndTime: hoursDeliveryEndTime,
  }
}
